export default __webpack_public_path__ + "static/media/Cross.ec34181d.svg";